// Where a subscribed member lands after they log in.
export const SUBSCRIBED_HOME_PATH = '/account';

// Paths a subscribed member may already be on. `/thank-you` stays so the end
// of onboarding can still show the download screen. Booking and feedback stay
// so a return from checkout is not pulled onto the account page. This
// redirect only replaces `/thank-you` as the destination for a login.
const STAY_PATHS = [
  'thank-you',
  'account',
  'schedule-appointment',
  'feedback',
  'dashboard',
  'hc-dashboard',
  'settings',
  'user-details',
];

export const subscribedUserMayStay = (pathname: string) =>
  STAY_PATHS.some(
    (path) => pathname === `/${path}` || pathname.startsWith(`/${path}/`)
  );
